import { calcRemainDays } from '@/utils/trial'

function pickText(...values) {
  for (const val of values) {
    if (val !== undefined && val !== null && String(val).trim() !== '') {
      return String(val).trim()
    }
  }
  return ''
}

function pickCompany(source) {
  if (!source || typeof source !== 'object') return ''
  const company = source.company
  if (typeof company === 'string') return company.trim()
  if (company && typeof company === 'object') {
    return pickText(company.company, company.name, company.title)
  }
  return pickText(source.company_name, source.companyName, source.user_company)
}

function resolveProfileSource(data = {}) {
  if (data.info && typeof data.info === 'object') return data.info
  if (data.user && typeof data.user === 'object') return data.user
  if (data.user_info && typeof data.user_info === 'object') return data.user_info
  // info 字段与 commission_stats 平铺在 data 上
  if (data.nickname || data.tel || data.user_id) return data
  return {}
}

/**
 * 解析 User/index 返回的用户资料
 * info 常见字段：nickname, tel, user_id, type_title, company / company_name
 */
export function parseUserProfileFromIndex(data = {}) {
  const profile = resolveProfileSource(data)
  const stats = data.commission_stats || {}

  const name = pickText(
    profile.nickname,
    profile.name,
    profile.user_name,
    data.nickname,
    data.name,
    stats.nickname,
    stats.name,
    localStorage.getItem('userName')
  )

  const tel = pickText(
    profile.tel,
    profile.mobile,
    profile.phone,
    data.tel,
    data.mobile,
    data.phone
  )

  const company = pickText(
    pickCompany(profile),
    pickCompany(data),
    pickCompany(stats)
  )

  const auditStatus =
    data.audit_status != null ? data.audit_status : profile.audit_status

  const trialEndTime = pickText(
    data.trial_end_time,
    profile.trial_end_time,
    data.trial_expire_time,
    profile.trial_expire_time
  )

  const remainDays =
    data.remain_days != null
      ? Number(data.remain_days)
      : profile.remain_days != null
      ? Number(profile.remain_days)
      : calcRemainDays(trialEndTime)

  const userId = profile.user_id || profile.id || data.user_id || data.id

  return {
    name,
    tel,
    company,
    type_title: pickText(profile.type_title, data.type_title),
    audit_status: auditStatus,
    trial_end_time: trialEndTime,
    remain_days: remainDays,
    user_id: userId,
  }
}
